module.exports = "<lfwms-searchable-entity-dynamic-details [serviceFactory]=\"serviceFactory\"></lfwms-searchable-entity-dynamic-details>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-details/reports-configuration-details.component.html
// module id = ../../../../../src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-details/reports-configuration-details.component.html
// module chunks = main